<template>
  <div class="h-full flex flex-col">
    <!-- ヘッダー -->
    <div class="flex items-center h-10 mx-5 my-3">
      <!-- 投稿者アイコン -->
      <img
        :src="userIcon"
        class="h-10 w-10 rounded-[20px] shadow-icon mr-4"
        @click="goToMenuTop()"
      />
      <!-- タグ/投稿者検索 -->
      <div
        class="flex w-full text-W5 text-[12px] leading-[20px] border-[1px] border-gray300 py-2 px-4 rounded-[8px] mr-3"
        @click="isShowTagSearchSuggest = true"
      >
        <img src="@/assets/dokoiku/HashTag.svg" class="w-4 h-4" />
        <span class="ml-2">タグから探す</span>
      </div>
      <!-- 地図で探す -->
      <div
        class="flex w-full text-W5 text-[12px] leading-[20px] border-[1px] border-gray300 py-2 px-4 rounded-[8px]"
        @click="goToNearbySearchMap()"
      >
        <img src="@/assets/dokoiku/MapIcon.svg" class="w-4 h-4" />
        <span class="ml-2">地図から探す</span>
      </div>
    </div>
    <div class="border-t-[1px] border-gray300" />
    <!-- Topに戻るボタン -->
    <ScrollTopButton
      targetId="timeline-contents"
      class="fixed bottom-[72px] right-5"
    />
    <!-- タイムライン -->
    <div
      class="flex-1 overflow-y-auto overscroll-none bg-gray200"
      id="timeline-contents"
      ref="scrollContainer"
    >
      <div class="h-2 w-full" />
      <PullToRefreshAndPagination
        @refresh="handleRefresh"
        @pagination="handlePagination"
        @scroll="handleScroll"
        ref="timeline"
      >
        <!-- 絞り込み枠 -->
        <div
          class="flex items-center h-[53px] mx-5"
          @click="showConditionModal()"
        >
          <!-- 現在の絞り込み条件 -->
          <div
            class="flex-1 text-left text-W4 text-[11px] leading-[19px]"
            :class="fontColorConditionDescriptionClass"
          >
            {{ explanationSearchConditions }}
          </div>
          <!-- 絞り込みボタン -->
          <div
            class="flex bg-white rounded-[37px] py-1 px-2.5"
            :class="fontColorConditionChangeButtonClass"
          >
            <img class="mt-1 h-3 w-3" src="@/assets/Icon_Filter.svg" />
            <div class="ml-2 text-W4 text-[13px] leading-[20.8px]">
              条件を変更
            </div>
          </div>
        </div>
        <template v-if="isFetchFailed">
          <div class="mt-16">
            <div class="text-W4 text-gray400 text-[13px] leading-[23px]">
              投稿を取得できませんでした
            </div>
            <div class="my-4 flex justify-center">
              <img :src="errorSrc" class="h-[140px] w-[140px]" />
            </div>
            <TheButton
              text="再読み込み"
              class="m-auto w-[123px]"
              @click-button="initialTimeline()"
            />
          </div>
        </template>
        <template v-else>
          <!-- 投稿一覧 -->
          <div
            v-for="(comment, index) in timelineData"
            :key="comment.commentId"
          >
            <div v-if="index !== 0" class="h-2 w-full bg-gray200" />
            <CommentCard
              :comment="comment"
              @on-click-comment="goToCommentDetail(comment)"
            />
          </div>
        </template>
      </PullToRefreshAndPagination>
      <div class="h-[80px] w-full bg-gray200" />
    </div>
    <!-- タグ検索パネル -->
    <TagSearchSuggest
      :isShowTagSearchSuggest="isShowTagSearchSuggest"
      @click-back-button="isShowTagSearchSuggest = false"
      @select-tag="goToTagSearchResult($event)"
    ></TagSearchSuggest>
    <!-- 条件を変更ポップアップ -->
    <Modal
      v-show="isShowCommentSearchConditionSettings"
      :isShowCloseButton="true"
      :isModalCenter="true"
      @disPlayModal="closeConditionsModal()"
      modalPaddingX="20px"
    >
      <div class="px-4 pt-9 pb-4">
        <!-- タイトル -->
        <div class="mb-6 text-W7 text-[17px] leading-[25.5px]">条件を変更</div>
        <!-- 現在地からの範囲 -->
        <div class="mb-5">
          <div class="mb-px text-left text-W6 text-[13px] leading-[18.2px]">
            現在地からの範囲
          </div>
          <div>
            <div
              class="rounded-[8px] flex bg-gray200 mb-4 px-4 py-3"
              @click="showSelectBox()"
            >
              <div
                class="flex-auto w-1/2 text-W4 text-[15px] leading-[18.2px] text-gray600"
              >
                {{ tmpCommentCondition.selectedSpotSearchRange }}
                <span v-if="!noLimitRange">km</span>
              </div>
              <img
                class="flex-none h-2.5 w-2.5 mt-1"
                src="@/assets/Icon_down_gray.svg"
              />
            </div>
          </div>
        </div>
        <!-- 並べ替え -->
        <div class="mb-8">
          <div class="mb-px text-left text-W7 text-[13px] leading-[23x]">
            並べ替え
          </div>
          <div class="flex flex-wrap">
            <div
              class="mr-2"
              v-for="sortInfo in tmpCommentCondition.sortInfoList"
              :key="sortInfo.sortName"
            >
              <RadioButton
                class="rounded-[8px]!"
                :title="sortInfo.title"
                :isValid="sortInfo.isSelected"
                @click="
                  changeSortInfo(tmpCommentCondition.sortInfoList, sortInfo)
                "
              />
            </div>
          </div>
        </div>
        <!-- ボタン -->
        <div class="items-center">
          <div
            class="text-W5 text-primary underline text-[13px] leading-[18px] mx-auto mb-6"
            @click="InitializeFilterCondition()"
          >
            条件をクリア
          </div>
          <div
            class="text-W7 the-button-default text-[15px] leading-[15px] py-4 mx-auto mb-2"
            @click="reSearchComment()"
          >
            再検索
          </div>
        </div>
      </div>
    </Modal>
    <!-- 検索範囲用セレクトボックス -->
    <Modal
      v-show="isShowSelectBox"
      :isShowCloseButton="true"
      :isModalCenter="true"
      @disPlayModal="closeSelectBox()"
      modalPaddingX="20px"
    >
      <div class="">
        <BaseBox class="bg-white !rounded-[16px]">
          <template v-slot:explanation>
            <div class="divide-y divide-gray300">
              <div
                v-for="(item, index) in displaySearchRangeList"
                :key="index"
                class="text-[15px] text-W5 font-semibold leading-[19px] text-center py-5 px-6"
                @click="clickRange(item)"
              >
                {{ item }}
                <span v-if="item !== noRangeString">km</span>
              </div>
            </div>
          </template>
        </BaseBox>
      </div>
    </Modal>
  </div>
</template>

<script>
import CommentCard from '@/components/organisms/dokoiku/CommentCard.vue'
import PullToRefreshAndPagination from '@/components/molecules/PullToRefreshAndPagination.vue'
import TheButton from '@/components/atoms/TheButton.vue'
import TagSearchSuggest from '@/components/organisms/dokoiku/TagSearchSuggest.vue'
import Modal from '@/components/Modal.vue'
import Util from '@/mixins/util'
import RadioButton from '@/components/atoms/RadioButton.vue'
import ScrollTopButton from '@/components/atoms/ScrollTopButton.vue'
import BaseCheckBox from '@/components/atoms/BaseCheckBoxV2.vue'
import BaseBox from '@/components/atoms/BaseBox.vue'
import SelectBox from '@/components/molecules/SelectBox.vue'
import {navigateTo} from '@/router'
import {
  getDokoikuTimeLineCommentConditions,
  setDokoikuTimeLineCommentConditions,
} from '@/utils/localStorageUtil'
import NativeUtil from '@/mixins/nativeUtil.js'

const FIRST_PAGE = 0
const SPOT_SEARCH_RANGE = ['1', '5', '10', '100']
const SORT_LIST = [
  {
    title: '距離が近い順',
    isSelected: false,
    sortName: 'distance',
    sortPattern: 'asc',
  },
  {
    title: '投稿日が新しい順',
    isSelected: false,
    sortName: 'createAt',
    sortPattern: 'desc',
  },
]
const Timeline = {
  name: 'Timeline',
  components: {
    CommentCard,
    PullToRefreshAndPagination,
    TheButton,
    TagSearchSuggest,
    Modal,
    RadioButton,
    BaseCheckBox,
    BaseBox,
    SelectBox,
    ScrollTopButton,
  },
  data() {
    return {
      isShowTagSearchSuggest: false, // タグ検索パネル表示フラグ
      errorSrc: Util.methods.getErrorAssetsSrc(), // 検索失敗時の画像パス
      isShowCommentSearchConditionSettings: false, // 条件変更パネル表示フラグ
      isShowSelectBox: false, // セレクトボックス表示フラグ
      displaySearchRangeList: [
        ...SPOT_SEARCH_RANGE,
        this.$config.SPOT_SEARCH_NO_RANGE,
      ], // 表示用範囲一覧
      noRangeString: this.$config.SPOT_SEARCH_NO_RANGE, // 範囲指定不要時の文言
      confirmCommentCondition: {
        selectedSpotSearchRange: '',
        sortInfoList: [],
      }, // 確定した検索条件(説明文言表示、API実行時に使用)
      tmpCommentCondition: {
        selectedSpotSearchRange: '',
        sortInfoList: [],
      }, // 絞り込みモーダル表示用一時領域
    }
  },
  computed: {
    /**
     * タイムライン記事情報
     */
    timelineData: {
      get() {
        return this.$store.state.DokoikuStore.timeline.commentList
      },
      set(value) {
        let newList = []
        if (this.offset === FIRST_PAGE) {
          // 先頭ページ読み込みの場合、新しく置き換え
          newList = value
        } else {
          // 続きのページ読み込みの場合、タイムライン追加
          const currentCommentList =
            this.$store.state.DokoikuStore.timeline.commentList
          const tmpCommentList = structuredClone(currentCommentList)
          tmpCommentList.push(...value)
          newList = tmpCommentList
        }
        this.$store.commit('DokoikuStore/setTimelineInfo', {
          key: 'commentList',
          value: newList,
        })
      },
    },
    /** ページネーション情報 */
    offset: {
      get() {
        return this.$store.state.DokoikuStore.timeline.offset
      },
      set(value) {
        this.$store.commit('DokoikuStore/setTimelineInfo', {
          key: 'offset',
          value: value,
        })
      },
    },
    /** タイムライン取得失敗有無 */
    isFetchFailed: {
      get() {
        return this.$store.state.DokoikuStore.timeline.isFetchFailed
      },
      set(value) {
        this.$store.commit('DokoikuStore/setTimelineInfo', {
          key: 'isFetchFailed',
          value: value,
        })
      },
    },
    /** スクロール位置 */
    scrollPosition: {
      get() {
        return this.$store.state.DokoikuStore.timeline.scrollPosition
      },
      set(value) {
        this.$store.commit('DokoikuStore/setTimelineInfo', {
          key: 'scrollPosition',
          value: value,
        })
      },
    },
    /**
     * ユーザー情報
     */
    user: {
      get() {
        return this.$store.state.user.appInfo
      },
    },
    /**
     * ユーザーアイコン取得
     */
    userIcon: {
      get() {
        return this.user.icon || require('@/assets/menu/icon_guest.svg')
      },
    },
    /**
     * 位置情報
     */
    currentPosition: {
      get() {
        const {lat, lon} = this.$store.state.currentPosition
        return {lat, lon}
      },
    },
    /**
     * 確定したソート情報
     */
    confirmSortInfo: {
      get() {
        return this.confirmCommentCondition.sortInfoList.find(
          (sort) => sort.isSelected == true
        )
      },
    },
    /**
     * 位置情報取得有無
     */
    existCurrentPosition: {
      get() {
        const {lat, lon} = this.currentPosition
        return lat != null && lon != null
      },
    },
    /**
     * 条件説明文のフォントカラー
     */
    fontColorConditionDescriptionClass: {
      get() {
        return this.existCurrentPosition ? 'text-primary' : 'text-gray'
      },
    },
    /**
     * 条件変更ボタンのフォントカラー
     */

    fontColorConditionChangeButtonClass: {
      get() {
        return this.existCurrentPosition ? '' : 'opacity-40'
      },
    },
    /**
     * 検索条件文言の切り替え
     * パターン1:範囲を指定しない・距離が近い順
     * パターン2:範囲を指定しない・投稿日が新しい順
     * パターン3:XXkm以内・距離が近い順
     * パターン4:XXkm以内・投稿日が新しい順
     * パターン5:位置情報を取得すると条件を変更できます
     */
    explanationSearchConditions: {
      get() {
        // パターン5
        if (!this.existCurrentPosition) {
          return '位置情報を取得すると条件を変更できます'
        }

        // パターン1~4
        const range =
          this.confirmCommentCondition.selectedSpotSearchRange ===
          this.noRangeString
            ? this.noRangeString
            : `${this.confirmCommentCondition.selectedSpotSearchRange}km以内`
        return `${range}・${this.confirmSortInfo.title}`
      },
    },
    /**
     * 範囲指定なし(絞り込み条件用一時メモリ向け)
     */
    noLimitRange: {
      get() {
        return (
          this.tmpCommentCondition.selectedSpotSearchRange ===
          this.noRangeString
        )
      },
    },
  },
  async created() {
    this.setFilterCondition()
    this.initialTimeline()
  },
  mounted() {
    const el = document.getElementById('timeline-contents')
    el.addEventListener('scroll', this.$refs.timeline.handleScroll)
  },
  activated() {
    // マップスクリプトの取得
    this.loadMap()
    // アクティブになったタイミングで、スクロール位置を元の状態に切り替える。
    this.$nextTick(() => {
      this.$refs.scrollContainer.scrollTop = this.scrollPosition
    })
  },
  methods: {
    /**
     * ポートマップの読み込みを行う
     */
    loadMap() {
      const id = this.$config.MAP_SCRIPT_ELEMENT_ID.DOKOIKU_MAP
      const mapElement = document.getElementById(id)
      // 既に取得済みの場合は何もしない
      if (mapElement) return

      // 地図情報を取得し保持
      this.$store.dispatch('getMapScript', {
        success: (data) => this.addMapScript(window.atob(data)),
      })
    },
    /**
     * マップスクリプト追加
     * @param {String} base64Script mapscript
     */
    addMapScript(base64Script) {
      const id = this.$config.MAP_SCRIPT_ELEMENT_ID.DOKOIKU_MAP
      let script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.setAttribute('id', id)
      script.text = base64Script
      document.head.appendChild(script)
    },
    /**
     * タイムライン記事更新処理
     * @param {Number} offset 次投稿データ開始位置
     * @returns {Array} 取得した記事情報
     */
    fetchTimeline(offset) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('DokoikuStore/fetchTimeline', {
          success: (result) => {
            resolve(result)
          },
          failed: () => {
            reject()
          },
          error: (e) => {
            reject(e)
          },
          lat: this.currentPosition.lat,
          lon: this.currentPosition.lon,
          range:
            this.confirmCommentCondition.selectedSpotSearchRange ===
            this.noRangeString // 範囲指定なし設定の場合はkey自体なし
              ? undefined
              : this.confirmCommentCondition.selectedSpotSearchRange,
          sortName: this.confirmSortInfo.sortName,
          sortPattern: this.confirmSortInfo.sortPattern,
          offset: offset,
        })
      })
    },
    /**
     * 初回表示時のタイムライン記事更新処理
     */
    async initialTimeline() {
      this.$store.commit('startLoading')
      try {
        const {items} = await this.fetchTimeline(this.offset)
        if (items.length === 0 /* eslint-disable-line no-magic-numbers*/) {
          throw new Error()
        }
        this.timelineData = items
        this.offset = this.timelineData.length
        this.isFetchFailed = false
      } catch (e) {
        // 取得失敗処理
        this.isFetchFailed = true
        this.timelineData = []
        const status = e?.response?.status
        if (status === this.$config.API_STATUS_CODE_SERVICE_UNAVAILABLE) {
          // メンテナンスモードの場合、エラーをスローする
          throw e
        }
      } finally {
        this.$store.commit('endLoading')
      }
    },
    /**
     * リフレッシュ操作時処理
     * @param {Function} refreshDone 終了処理
     */
    async handleRefresh(refreshDone) {
      // ページを先頭に戻し、投稿一覧を更新
      this.offset = 0
      try {
        const {items} = await this.fetchTimeline(this.offset)
        if (items.length === 0 /* eslint-disable-line no-magic-numbers*/) {
          throw new Error()
        }
        this.timelineData = items
        this.offset = this.timelineData.length
        this.isFetchFailed = false
      } catch (e) {
        // 取得失敗処理
        this.isFetchFailed = true
        this.timelineData = []
        const status = e?.response?.status
        if (status === this.$config.API_STATUS_CODE_SERVICE_UNAVAILABLE) {
          // メンテナンスモードの場合、終了処理を行った上エラーをスローする
          refreshDone()
          throw e
        }
      }
      refreshDone()
    },
    /**
     * ページネーション操作時処理
     * @param {Function} paginationDone 終了処理 引数:スクロール対象要素ID
     */
    async handlePagination(paginationDone) {
      // ページを更新し、投稿一覧を追加
      const prevPage = structuredClone(this.offset)
      try {
        const {items} = await this.fetchTimeline(this.offset)
        if (items.length === 0 /* eslint-disable-line no-magic-numbers*/) {
          throw new Error()
        }
        this.timelineData = items
        this.offset = this.timelineData.length
      } catch (e) {
        // 取得失敗処理
        // 元のページに戻す
        this.offset = prevPage
        const status = e?.response?.status
        if (status === this.$config.API_STATUS_CODE_SERVICE_UNAVAILABLE) {
          // メンテナンスモードの場合、終了処理を行った上エラーをスローする
          paginationDone('timeline-contents')
          throw e
        }
      }
      paginationDone('timeline-contents')
    },
    /** 再検索ボタン押下処理 */
    reSearchComment() {
      this.offset = 0 // リフレッシュのため
      this.isShowCommentSearchConditionSettings = false

      const {selectedSpotSearchRange, sortInfoList} = this.tmpCommentCondition
      const sortInfo = sortInfoList.find((sort) => sort.isSelected == true)

      // API検索用条件情報を更新
      this.confirmCommentCondition = structuredClone(this.tmpCommentCondition)

      // ストレージに保存
      setDokoikuTimeLineCommentConditions(selectedSpotSearchRange, sortInfo)
      // 投稿一覧取得
      this.initialTimeline()
    },
    /**
     * タイムラインスクロール処理
     * @param {Number} scrollTop スクロール位置
     */
    handleScroll(scrollTop) {
      this.scrollPosition = scrollTop
    },
    /**
     * メニュー画面に遷移
     */
    goToMenuTop() {
      navigateTo({name: this.$config.DISPLAY_MENU_TOP})
    },
    /**
     * 周辺検索画面に遷移
     */
    goToNearbySearchMap() {
      this.$store.dispatch('PageControl/saveDokoikuHistoryPage', this.$route)
      navigateTo({name: this.$config.DISPLAY_DOKOIKU_NEARBY_SEARCH_MAP})
    },
    /**
     * コメント詳細画面へ遷移
     * @param {Object} comment 選択した記事
     */
    goToCommentDetail(comment) {
      this.$store.commit('DokoikuStore/initCommentDetailInfo')
      this.$store.commit('DokoikuStore/setCommentDetailInfo', {
        key: 'selectedComment',
        value: comment,
      })
      // 画面を離れる前にページ情報を保持
      this.$store.dispatch('PageControl/saveDokoikuHistoryPage', this.$route)
      navigateTo({name: this.$config.DISPLAY_DOKOIKU_COMMENT_DETAIL})
      NativeUtil.methods.sendViewDokoikuCommentPageLogEventForGA(
        comment.contributorId,
        comment.commentId,
        comment.title
      )
    },
    /**
     * 選択されたタグ情報を保存し、タグ検索結果画面に遷移
     * @param {Object} tag 検索画面からタップされたタグ情報
     */
    goToTagSearchResult(tag) {
      this.isShowTagSearchSuggest = false // keep-aliveにより表示状態が保持されるため、明示的に非表示
      this.$store.commit('DokoikuStore/initTagSearchResultInfo')
      this.$store.commit('DokoikuStore/setTagSearchResultInfo', {
        key: 'selectTag',
        value: tag,
      })
      // 画面を離れる前にページ情報を保持
      this.$store.dispatch('PageControl/saveDokoikuHistoryPage', this.$route)
      navigateTo({name: this.$config.DISPLAY_DOKOIKU_TAG_SEARCH_RESULT})
    },
    /**
     * 条件設定モーダルの展開処理
     * 位置情報が取れていれば展開
     */
    showConditionModal() {
      if (this.existCurrentPosition) {
        this.isShowCommentSearchConditionSettings = true
      }
    },
    /**
     * ソート情報の選択状態更新処理
     * @param {Array} list ソートのリスト
     * @param {Object} sortInfo 選択されたソート情報
     * @returns 選択状態を更新したソートのリスト
     */
    changeSortInfo(list, sortInfo) {
      return list.map((sort) => {
        if (
          sort.sortName == sortInfo.sortName &&
          sort.sortPattern == sortInfo.sortPattern
        ) {
          // タップしたソート情報を選択状態にする
          sort.isSelected = true
        } else {
          // タップされてないソート情報は未選択状態にする
          sort.isSelected = false
        }
        return sort
      })
    },
    /**
     * セレクトボックス展開
     * セレクトボックス展開時は、条件モーダルを非表示にする
     */
    showSelectBox() {
      this.isShowCommentSearchConditionSettings = false
      this.isShowSelectBox = true
    },
    /**
     * 範囲距離がクリックされた際の処理
     * @param {Object} item 選択対象の検索範囲情報
     */
    clickRange(item) {
      this.isShowSelectBox = false
      this.tmpCommentCondition.selectedSpotSearchRange = item
      this.isShowCommentSearchConditionSettings = true
    },
    /**
     * セレクトボックス閉じる
     * 条件モーダルは非表示状態から再表示させる
     */
    closeSelectBox() {
      this.isShowCommentSearchConditionSettings = true
      this.isShowSelectBox = false
    },
    /**
     * 絞り込みモーダル閉じる
     */
    closeConditionsModal() {
      // 一時的絞り込み条件情報を最後に検索した状態に戻す
      this.tmpCommentCondition = structuredClone(this.confirmCommentCondition)
      this.isShowCommentSearchConditionSettings = false
    },
    /**
     * 絞り込み索条件を初期状態にする
     */
    InitializeFilterCondition() {
      this.tmpCommentCondition = structuredClone({
        selectedSpotSearchRange: this.noRangeString,
        sortInfoList: this.changeSortInfo(SORT_LIST, {
          sortName: 'distance',
          sortPattern: 'asc',
        }),
      })
    },
    /**
     * ストレージから検索条件を取得、メモリに格納
     */
    setFilterCondition() {
      const {selectedSpotSearchRange, selectedSortInfo} =
        getDokoikuTimeLineCommentConditions()

      // 位置情報取れない場合、投稿日順でAPI実行
      const sortInfo = this.existCurrentPosition
        ? selectedSortInfo
        : {
            sortName: 'createAt',
            sortPattern: 'desc',
          }

      // ソートの選択ステータス更新し、モーダル上でどれが選択状態か見えるようにする
      const selectedSortInfoList = this.changeSortInfo(SORT_LIST, sortInfo)

      // API実行時用情報の更新
      this.confirmCommentCondition = {
        selectedSpotSearchRange,
        sortInfoList: selectedSortInfoList,
      }

      // 絞り込みモーダル表示用一時領域の更新
      this.tmpCommentCondition = structuredClone(this.confirmCommentCondition)
    },
  },
}
export default Timeline
</script>

<style scooped></style>
